import Form from './form'

export default class ReservationForm extends Form {
  constructor(form) {
    super(form)
    this.dates = this.form.querySelector('.reservation-form__dates')
    this.departureDate = this.form.querySelector('.reservation-form__dates__departure')
    this.returnDate = this.form.querySelector('.reservation-form__dates__return')

    this.watchDepartureDate()
    this.watchBookingFlow()
  }

  formatDate(date) {
    return `${date}T00:00:00`
  }

  validate() {
    const formData = new FormData(this.form)
    const { bipLang } = window

    const bookingFlow = formData.get('bookingFlow')
    const routeFrom = formData.get('routeFrom')
    const routeTo = formData.get('routeTo')
    const ADL = formData.get('ADL')
    const departureDate = formData.get('departureDate')
    const returnDate = formData.get('returnDate')
    const today = formData.get('today')

    if (!bookingFlow) {
      this.showMessage(bipLang.flow_required ?? 'Por favor seleccione un flujo de reserva.', true)
      return false
    }

    if (!routeFrom) {
      this.showMessage(
        bipLang.from_required ?? 'Por favor seleccione una ubicación en Desde.',
        true,
      )
      return false
    }

    if (!routeTo) {
      this.showMessage(bipLang.to_required ?? 'Por favor seleccione una ubicación en Hasta.', true)
      return false
    }

    if (!departureDate) {
      this.showMessage(
        bipLang.departure_date_required ?? 'Por favor seleccione una Fecha de Ida.',
        true,
      )
      return false
    }

    if (bookingFlow === 'RETURN' && !returnDate) {
      this.showMessage(
        bipLang.return_date_required ?? 'Por favor seleccione una Fecha de Vuelta.',
        true,
      )
      return false
    }

    if (!ADL) {
      this.showMessage(bipLang.adults_required ?? 'Por favor seleccione al menos un adulto.', true)
      return false
    }

    const todayObj = new Date(today)
    const departureDateObj = new Date(departureDate)
    const returnDateObj = new Date(returnDate)

    if (departureDateObj < todayObj) {
      this.showMessage(
        bipLang.departure_date_not_before_today ??
          'La fecha de ida no puede ser anterior a la fecha actual.',
        true,
      )
      return false
    }

    if (returnDateObj < departureDateObj) {
      this.showMessage(
        bipLang.return_date_not_before_departure ??
          'La fecha de vuelta no puede ser anterior a la fecha de ida.',
        true,
      )
      return false
    }

    if (routeFrom === routeTo) {
      this.showMessage(
        bipLang.from_to_same ?? 'Las ubicaciones de origen y destino no pueden ser iguales.',
        true,
      )
      return false
    }

    return true
  }

  async handleSubmit(e) {
    e.preventDefault()

    if (!this.fetchUrl) {
      throw new Error('Form - No action parameter specified')
    }

    this.clearMessage()
    this.disableForm()

    if (!this.validate()) {
      return this.enableForm()
    }

    const url = new URL(this.fetchUrl)
    const urlParams = new URLSearchParams()

    const formData = new FormData(this.form)
    const bookingFlow = formData.get('bookingFlow')
    const routeFrom = formData.get('routeFrom')
    const routeTo = formData.get('routeTo')
    const departureDate = formData.get('departureDate')
    const returnDate = formData.get('returnDate')
    const ADL = formData.get('ADL')
    const CHD = formData.get('CHD')

    url.pathname = '/en/book/new-booking/'
    urlParams.append('cw_ajax', 'dobookingform')
    urlParams.append('redirect', 'true')
    urlParams.append('bookingFlow', bookingFlow)
    urlParams.append('cw_journeysearch_j1_route', `P~${routeFrom}-P~${routeTo}`)
    urlParams.append('cw_journeysearch_j1_date', this.formatDate(departureDate))

    if (bookingFlow === 'RETURN') {
      urlParams.append('cw_journeysearch_j2_route', `P~${routeTo}-P~${routeFrom}`)
      urlParams.append('cw_journeysearch_j2_date', this.formatDate(returnDate))
    }

    urlParams.append('cw_journeysearch_j1_passengers[0][ctg]', 'ADL')
    urlParams.append('cw_journeysearch_j1_passengers[0][qty]', ADL)
    urlParams.append('cw_journeysearch_j1_passengers[1][ctg]', 'CHD')
    urlParams.append('cw_journeysearch_j1_passengers[1][qty]', CHD)

    if (bookingFlow === 'RETURN') {
      urlParams.append('cw_journeysearch_j2_passengers[0][ctg]', 'ADL')
      urlParams.append('cw_journeysearch_j2_passengers[0][qty]', ADL)
      urlParams.append('cw_journeysearch_j2_passengers[1][ctg]', 'CHD')
      urlParams.append('cw_journeysearch_j2_passengers[1][qty]', CHD)
    }

    url.search = urlParams.toString()
    window.location.href = decodeURIComponent(url.toString())

    return this.enableForm()
  }

  showMessage(message, error = false) {
    this.clearMessage()

    const cssClasses = ['form__helper', 'notice']
    if (error) {
      cssClasses.push('error')
      cssClasses.push('form__helper--error')
    } else {
      cssClasses.push('updated')
    }

    this.errorMessage = document.createElement('div')
    this.errorMessage.className = cssClasses.join(' ')
    this.errorMessage.innerHTML = `<p>${message}</p>`

    this.dates.insertBefore(this.errorMessage, this.submitWrapper)
  }

  watchDepartureDate() {
    const departureInput = this.departureDate.querySelector('input')
    if (departureInput) {
      departureInput.addEventListener('change', event => {
        const { value } = event.target

        if (!this.returnDate) {
          return
        }

        const returnInput = this.returnDate.querySelector('input')

        if (returnInput) {
          returnInput.min = value
        }
      })
    }
  }

  watchBookingFlow() {
    const radios = document.querySelectorAll('input[type="radio"][name="bookingFlow"]')

    radios.forEach(radio => {
      radio.addEventListener('change', event => {
        const { value } = event.target

        if (!this.returnDate) {
          return
        }

        if (value === 'RETURN') {
          this.returnDate.classList.remove('hidden')
          this.returnDate.querySelectorAll('input').forEach(input => {
            input.required = true
          })
        } else {
          this.returnDate.classList.add('hidden')
          this.returnDate.querySelectorAll('input').forEach(input => {
            input.required = false
          })
        }
      })
    })
  }
}
